module.exports = __webpack_public_path__ + "img/a3-s56.cec38e1c.jpg";